import React from 'react';
import { Card } from './Card';

interface ContentCardProps {
  html: string;
  className?: string;
}

export const ContentCard: React.FC<ContentCardProps> = ({ html, className = '' }) => {
  return (
    <Card className={`p-6 sm:p-8 ${className}`}>
      <div
        className="prose prose-gray max-w-none"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </Card>
  );
};
